import C from 'cesium';

import * as layerOps from '../../api/Layers/layer-operations';

import adaptURL from '../adapt-url';

/**
 * Builds the tile server provider for the viewer.
 *
 * @param {object} layer - The layer object.
 * @returns {object} The cesium layer to add to the viewer.
 */
const build3DTileset = layer => {
  const tileset = new C.Cesium3DTileset({
    url: adaptURL(layerOps.getURL(layer)),
    skipLevelOfDetail: true,
    baseScreenSpaceError: 1024,
    maximumMemoryUsage: 2048,
    maximumScreenSpaceError: 64,
    skipScreenSpaceErrorFactor: 128,
    skipLevels: 1,
    immediatelyLoadDesiredLevelOfDetail: false,
    loadSiblings: false,
    cullWithChildrenBounds: true
  });
  return tileset;
};

export default build3DTileset;
